"use client";

import { GeneralPropsType } from "@/common/types";
import clsx from "clsx";
import BottomNavbar from "@/components/BottomNavbar";
import { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { useGlobalData } from "@/contexts/GlobalData";
import { useAuth } from "@/contexts/Auth";
import { useNotify } from "@/contexts/NotifyProvider";
import { ACTIVITY_TYPE, TRANSACTION_TYPE } from "@/common/const";
import { Modal, ModalContent, useDisclosure } from "@nextui-org/react";
import Banner from "@/components/Banner";
import GeneralPopup from "@/components/GeneralPopup";
import checkKycService from "@/services/checkKycService";
import { usePocketBaseData } from "@/contexts/Pocketbase";
import roundToTwoSignificantDecimals from "@/common/function/roundToTwoSignificantDecimals";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import LoginDigitalOTP from "@/components/LoginDigitalOTP";
import CheckNetwork from "@/components/CheckNetwork";
import ModalLayout from "@/components/ModalLayout";
import DynamicFontSize from "@/components/DynamicFontSize";
import PrimaryButton, { ButtonStatus } from "@/components/PrimaryButton";
import Link from "next/link";
import { initUtils } from "@tma.js/sdk";
import createConnectSocialService from "@/services/createConnectSocialService";
import generateRandomHexString from "@/utils/generateRandomHexString";
import { isTMA } from "@tma.js/sdk";
import useCasdoor from "@/hook/useCasdoor";
const prefix = "app_layout_";
import "tek-keyboard/dist/styles/input-keyboard.css";
function AppLayoutComponent({
  children
}: GeneralPropsType) {
  const searchParams = useSearchParams();
  const [linkAccountStatus, setLinkAccountStatus] = useState<ButtonStatus>("normal");
  const {
    userId,
    token,
    username
  } = useAuth();
  const noti = useNotify();
  const {
    translate,
    triggerHapticFeedBack,
    setTransaction,
    activityDetail,
    setActivityDetail,
    transaction,
    setKycDataUser,
    activityData,
    pb,
    hideBottomNavbar,
    statusBarHeight,
    setStatusBarHeight,
    isLimitSize,
    screenSize,
    authenInfo,
    runEffectNavigation,
    userInfo
  } = useGlobalData();
  const bottomNavbarRef = useRef<HTMLDivElement | null>(null);
  const {
    triggerTransaction
  } = usePocketBaseData();
  const pathname = usePathname();
  const [sdkCasdoorStateEmailBackup, signinEmailBackup] = useCasdoor("email_authen");

  // useEffect(() => {
  //     // console.log("🚀 ~ AppLayoutComponent ~ pathname:", pathname);
  //     console.log("🚀 ~ AppLayoutComponent ~ hideStatusBarHeight:", hideStatusBarHeight);
  //     if (hideStatusBarHeight) {
  //         console.log("🚀 ~ AppLayoutComponent ~ hideStatusBarHeight 0:", hideStatusBarHeight);
  //         setStatusBarHeight(0);
  //         return;
  //     }
  //     if (statusBarHeightQuery) {
  //         console.log("🚀 ~ useEffect ~ statusBarHeightQuery:", statusBarHeightQuery);
  //         setStatusBarHeight(+(statusBarHeightQuery ?? 0));
  //         localStorage.setItem("statusBarHeight", statusBarHeightQuery);
  //         return;
  //     }
  //     const oldStatusBarHeight = +(localStorage.getItem("statusBarHeight") ?? 0);
  //     console.log("🚀 ~ useEffect ~ oldStatusBarHeight:", oldStatusBarHeight);
  //     setStatusBarHeight(+(oldStatusBarHeight ?? 0));
  // }, [statusBarHeightQuery, hideStatusBarHeight]);

  useEffect(() => {
    try {
      if (process.env.NEXT_PUBLIC_ENV != "production" && window) {
        import("eruda").then(eruda => eruda.default.init());
      }
    } catch (err) {
      console.error("eruda init error", err);
    }
  }, []);
  useEffect(() => {
    !!bottomNavbarRef.current && (bottomNavbarRef.current.style.transform = "translateY(calc(-100% - 20px))");
  }, []);
  const router = useRouter();
  const prevClientY = useRef(0);
  const prevTime = useRef(new Date().getTime());
  const handleSmartNavbarOnTouch = (e: any) => {
    if (hideBottomNavbar) return;
    const currentClientY = e.touches && e.touches[0]?.clientY;
    const currentTime = new Date().getTime();
    const speed = (currentClientY - prevClientY.current) / (currentTime - prevTime.current);
    prevClientY.current = currentClientY;
    prevTime.current = currentTime;
    if (speed > 0.05 && !!bottomNavbarRef.current) {
      bottomNavbarRef.current.style.transform = "translateY(calc(-100% - 20px))";
      return;
    }
    if (speed < -0.05 && !!bottomNavbarRef.current) {
      bottomNavbarRef.current.style.transform = "translateY(100%)";
      return;
    }
  };
  useEffect(() => {
    if (!bottomNavbarRef.current) {
      return;
    }
    if (hideBottomNavbar) {
      bottomNavbarRef.current.style.transform = "translateY(100%)";
    } else {
      bottomNavbarRef.current.style.transform = "translateY(calc(-100% - 20px))";
    }
  }, [hideBottomNavbar]);
  useEffect(() => {
    try {
      const transactionType = triggerTransaction?.record?.transaction_type;
      const transactionStatus = triggerTransaction?.record?.status;
      const amount = +(triggerTransaction?.record?.amount ?? 0);
      const isReceive = triggerTransaction?.record?.is_receive && (transactionType == TRANSACTION_TYPE.GIFT || transactionType == TRANSACTION_TYPE.TRANSFER) ? "received_" : "";
      // const key =
      //     `${isReceive}${transactionType}_${transactionStatus}_before` +
      //     ` ${
      //         triggerTransaction?.record?.currency_name == "USD" ||
      //         triggerTransaction?.record?.transaction_type == "bonus-aff"
      //             ? "$"
      //             : ""
      //     }${!!amount ? roundToTwoSignificantDecimals(amount) : ""} ${
      //         triggerTransaction?.record?.currency_name != "USD" &&
      //         triggerTransaction?.record?.transaction_type != "bonus-aff"
      //             ? ` ${triggerTransaction?.record?.currency_name}`
      //             : ""
      //     } ` +
      //     `${transactionType}_${transactionStatus}_after`;
      const key = translate(`${isReceive}${transactionType}_${transactionStatus}_before`) + ` ${triggerTransaction?.record?.currency_name == "USD" || triggerTransaction?.record?.transaction_type == TRANSACTION_TYPE.BONUS_AFF ? "$" : ""}${!!amount ? roundToTwoSignificantDecimals(amount) : ""} ${triggerTransaction?.record?.currency_name != "USD" && triggerTransaction?.record?.transaction_type != TRANSACTION_TYPE.BONUS_AFF ? ` ${triggerTransaction?.record?.currency_name}` : ""} ` + translate(`${transactionType}_${transactionStatus}_after`);
      if (userId != triggerTransaction?.record?.user_id) {
        if (transactionType != "gift") return;
        if (username == triggerTransaction?.record?.from_user && transactionStatus == "success") {
          const activityDataFound = activityData?.find((item: any) => item?.status == "processing" && item?.transaction_type == TRANSACTION_TYPE.GIFT);
          if (!activityDataFound) return;
          const res = pb.collection("transactions").getFirstListItem(`hash="${activityDataFound?.hash}"`);
          if (res?.record?.status != "success") return;
          triggerHapticFeedBack("success");
          setTransaction({
            ...transaction,
            status: triggerTransaction?.record?.status
          });
          return noti?.success(key);
        }
        return;
      }
      // boost
      if (transactionType == TRANSACTION_TYPE.BOOST) {
        if (transactionStatus == "processing") return;
        if (triggerTransaction?.record?.id == transaction?.id) {
          setTransaction({
            ...transaction,
            status: triggerTransaction?.record?.status
          });
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        // if (transactionStatus == "processing") {
        //   return noti?.info(key)
        // }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      // withdraw-bonus
      if (transactionType == TRANSACTION_TYPE.WITHDRAW_BONUS) {
        if (transactionStatus == "processing") return;
        if (triggerTransaction?.record?.id == transaction?.id) {
          setTransaction({
            ...transaction,
            status: triggerTransaction?.record?.status
          });
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        // if (transactionStatus == "processing") {
        //   return noti?.info(key);
        // }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          noti?.error(key);
          return;
        }
      }
      if (transactionType == TRANSACTION_TYPE.BOOST_PACKAGE) {
        if (transactionStatus == "processing") {
          triggerHapticFeedBack("success");
          return noti?.info(key);
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        // if (transactionStatus == "processing") {
        //   return noti?.info(key);
        // }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          noti?.error(key);
          return;
        }
      }
      // receive bonus
      if (transactionType == TRANSACTION_TYPE.BONUS_AFF) {
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(triggerTransaction?.record?.type_bonus == "up-rank" ? `${translate(`${transactionType}_${transactionStatus}_${triggerTransaction?.record?.title}`)}` : key);
        }
      }
      // claim-boost-interest
      if (transactionType == TRANSACTION_TYPE.CLAIM_BOOST_INTEREST) {
        if (transactionStatus == "processing") return;
        if (triggerTransaction?.record?.id == transaction?.id) {
          setTransaction({
            ...transaction,
            status: triggerTransaction?.record?.status
          });
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        // if (transactionStatus == "processing") {
        //   return noti?.info(key);
        // }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      // claim-boost-principal
      if (transactionType == TRANSACTION_TYPE.CLAIM_BOOST_PRINCIPLE) {
        if (transactionStatus == "processing") return;
        if (triggerTransaction?.record?.id == transaction?.id) {
          setTransaction({
            ...transaction,
            status: triggerTransaction?.record?.status
          });
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        // if (transactionStatus == "processing") {
        //   return noti?.info(key);
        // }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      if (transactionType == TRANSACTION_TYPE.SWAP) {
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        if (transactionStatus == "processing") {
          triggerHapticFeedBack("success");
          return noti?.info(key);
        }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      if (transactionType == TRANSACTION_TYPE.UPDATE_PROFILE) {
        if (!triggerTransaction?.record?.amount || triggerTransaction?.record?.amount == "0") {
          if (transactionStatus == "success") {
            triggerHapticFeedBack("success");
            return noti?.success(translate(`noti updating profile ${transactionStatus}`));
          }
          if (transactionStatus == "processing") {
            triggerHapticFeedBack("success");
            return noti?.info(translate(`noti updating profile ${transactionStatus}`));
          }
          if (transactionStatus == "failed") {
            triggerHapticFeedBack("error");
            return noti?.error(translate(`noti updating profile ${transactionStatus}`));
          }
          return;
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        if (transactionStatus == "processing") {
          triggerHapticFeedBack("success");
          return noti?.info(key);
        }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      if (transactionType == TRANSACTION_TYPE.WITHDRAW) {
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        if (transactionStatus == "processing") {
          triggerHapticFeedBack("success");
          return noti?.info(key);
        }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      if (transactionType == TRANSACTION_TYPE.DEPOSIT) {
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        if (transactionStatus == "processing") {
          triggerHapticFeedBack("success");
          return noti?.info(key);
        }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      // gift
      if (transactionType == TRANSACTION_TYPE.GIFT) {
        if (triggerTransaction?.record?.id == transaction?.id && !triggerTransaction?.record?.is_receive) {
          setTransaction({
            ...transaction,
            status: triggerTransaction?.record?.status
          });
          setActivityDetail({
            ...activityDetail,
            status: triggerTransaction?.record?.status
          });
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        // if (transactionStatus == "processing") {
        //   return noti?.info(translate(key));
        // }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      if (transactionType == TRANSACTION_TYPE.TRANSFER) {
        console.log("heqwvfcqjelvuigtiewlqcguewt", triggerTransaction);
        if (triggerTransaction?.record?.id == transaction?.id && !triggerTransaction?.record?.is_receive) {
          setTransaction({
            ...transaction,
            status: triggerTransaction?.record?.status
          });
          setActivityDetail({
            ...activityDetail,
            status: triggerTransaction?.record?.status
          });
        }
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(key);
        }
        // if (transactionStatus == "processing") {
        //   return noti?.info(translate(key));
        // }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      //SUB AFF
      if (transactionType == ACTIVITY_TYPE.SUB_AFF) {
        if (transactionStatus == "success") {
          triggerHapticFeedBack("success");
          return noti?.success(translate(`sub_aff_noti_before`) + triggerTransaction?.record?.from_user + translate(`sub_aff_noti_after`));
        }
      }
      if (transactionType == ACTIVITY_TYPE.KYC_PAYMENT) {
        if (transactionStatus == "success") {
          checkKycService(token, data => {
            setKycDataUser(data);
            triggerHapticFeedBack("success");
            noti?.success(key);
          });
          return;
        }
        if (transactionStatus == "failed") {
          triggerHapticFeedBack("error");
          return noti?.error(key);
        }
      }
      if (transactionType == ACTIVITY_TYPE.KYC_REQUEST) {
        if (transactionStatus == "verified") {
          checkKycService(token, data => {
            setKycDataUser(data);
            triggerHapticFeedBack("success");
            noti?.success(key);
          });
          return;
        }
        if (transactionStatus == "requested") {
          checkKycService(token, data => {
            setKycDataUser(data);
            triggerHapticFeedBack("success");
            noti?.info(key);
          });
          return;
        }
        if (transactionStatus == "rejected") {
          checkKycService(token, data => {
            setKycDataUser(data);
            triggerHapticFeedBack("error");
            noti?.error(key);
          });
          return;
        }
      }
    } catch (err) {
      console.error("handleTransaction error", err);
    }
  }, [triggerTransaction]);
  const {
    isOpen: isOpenBanner,
    onOpen: onOpenBanner,
    onOpenChange: onOpenChangeBanner,
    onClose: onCloseBanner
  } = useDisclosure();
  const {
    isOpen: isOpenAllWallet,
    onOpen: onOpenAllWallet,
    onOpenChange: onOpenChangeAllWallet,
    onClose: onCloseAllWallet
  } = useDisclosure();
  const condition = useMemo(() => {
    if (!authenInfo) return null;
    return JSON.stringify(authenInfo);
  }, [authenInfo]);
  useEffect(() => {
    if (!!authenInfo && authenInfo?.status != "active" && userInfo && userInfo?.permissions?.required_email_authen) {
      onOpenAllWallet();
    } else {
      onCloseAllWallet();
    }
  }, [condition, userInfo]);
  const handleVerifyEmail = () => {
    runEffectNavigation();
    const state = generateRandomHexString(64);
    try {
      createConnectSocialService(token, state, "email-authen", "email_authen", async () => {
        setLinkAccountStatus("success");
        setTimeout(() => {
          setLinkAccountStatus("normal");
        }, 1000);
        const isCheckTele = await isTMA();
        if (isCheckTele) {
          const utils = initUtils();
          utils.openLink(`${window.location.origin}/email-authen-redirect?state=${state}`);
          return;
        }
        localStorage.setItem("isWeb", "true");
        localStorage.removeItem("isReload");
        signinEmailBackup(state);
      });
    } catch (error) {
      setLinkAccountStatus("error");
      setTimeout(() => {
        setLinkAccountStatus("normal");
      }, 1000);
      console.error(error);
    }
  };
  return <>
            <div className="fixed inset-0 flex">
                <div id="scroll-container" onTouchMove={handleSmartNavbarOnTouch} style={{
        backgroundImage: `url(/images/main_bg.jpg)`,
        ...(isLimitSize ? {
          width: `${screenSize?.realWidth}px`,
          height: `${screenSize?.realHeight}px`,
          borderRadius: `${screenSize?.realWidth * 0.08}px`,
          margin: "auto",
          boxShadow: "0 0 20px 0 #011125"
        } : {
          width: "100%",
          height: "100%"
        })
      }} className={clsx("overflow-x-hidden app_layout duration-300 !bg-cover !bg-no-repeat !bg-center relative bg-black", {
        "overflow-y-scroll": !hideBottomNavbar,
        "overflow-y-hidden": hideBottomNavbar
      })}>
                    {!!statusBarHeight && <div className="w-full" style={{
          height: `${statusBarHeight}px`
        }}></div>}
                    {children}
                    <div style={{
          width: isLimitSize ? `${screenSize?.realWidth - 32}px` : "initial",
          bottom: isLimitSize ? `${screenSize?.realHeight * 0.025}px` : "min(2.5vw, 5px)"
        }} className={clsx("fixed z-20", {
          "left-1/2 -translate-x-1/2": isLimitSize,
          "left-4 right-4 z-20 bottom-0 ": !isLimitSize
        })}>
                        {<BottomNavbar ref={bottomNavbarRef} className={clsx("absolute top-0 duration-[300ms] z-[999]", {})}></BottomNavbar>}
                    </div>
                    <Modal isOpen={isOpenBanner} placement="center" onOpenChange={onOpenChangeBanner} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-source-file="index.tsx">
                        <ModalContent className="rounded-none bg-transparent !m-0 flex flex-col items-center" data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
                            <Banner data-sentry-element="Banner" data-sentry-source-file="index.tsx"></Banner>
                        </ModalContent>
                    </Modal>
                    <CheckNetwork data-sentry-element="CheckNetwork" data-sentry-source-file="index.tsx" />
                    <GeneralPopup data-sentry-element="GeneralPopup" data-sentry-source-file="index.tsx" />
                    <LoginDigitalOTP data-sentry-element="LoginDigitalOTP" data-sentry-source-file="index.tsx" />
                </div>
            </div>
            <Modal isOpen={isOpenAllWallet} placement="bottom" onOpenChange={onOpenChangeAllWallet} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-source-file="index.tsx">
                <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]" data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
                    <ModalLayout boxClassName="max-h-dvh flex flex-col !border-error mt-auto" modalKey="4295e77a-0fac-47d3-937c-97c2b002596add" title={translate(prefix + "important warning")}
        // onClose={onCloseAllWallet}
        hideCloseButton hideOutsideClick data-sentry-element="ModalLayout" data-sentry-source-file="index.tsx">
                        <div className="flex flex-col">
                            <DynamicFontSize fontSize={14} className="text-white" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                {translate(prefix + "warning 1")}
                            </DynamicFontSize>
                            {translate(prefix + "warning 2") != " " && <DynamicFontSize fontSize={14} className="text-white mt-2">
                                    {translate(prefix + "warning 2")}
                                </DynamicFontSize>}
                            {translate(prefix + "warning 3") != " " && <DynamicFontSize fontSize={14} className="text-white mt-2">
                                    {translate(prefix + "warning 3")}
                                </DynamicFontSize>}
                            {translate(prefix + "warning 4") != " " && <DynamicFontSize fontSize={14} className="text-white mt-2 mb-6">
                                    {translate(prefix + "warning 4")}
                                </DynamicFontSize>}
                            <div className="flex items-center gap-3 justify-end w-full">
                                {/* <PrimaryButton onClick={onCloseAllWallet} className="!bg-transparent !text-error">
                                    {translate(prefix + "close")}
                                 </PrimaryButton> */}
                                <Link className="w-full" href="/setting?current_setting_tab=security&action=verify-email" onClick={handleVerifyEmail} data-sentry-element="Link" data-sentry-source-file="index.tsx">
                                    <PrimaryButton className="w-full" status={linkAccountStatus} data-sentry-element="PrimaryButton" data-sentry-source-file="index.tsx">
                                        {translate(prefix + "verify email")}
                                    </PrimaryButton>
                                </Link>
                            </div>
                        </div>
                    </ModalLayout>
                </ModalContent>
            </Modal>
        </>;
}
const AppLayout = ({
  children
}: GeneralPropsType) => {
  return <Suspense data-sentry-element="Suspense" data-sentry-component="AppLayout" data-sentry-source-file="index.tsx">
            <AppLayoutComponent data-sentry-element="AppLayoutComponent" data-sentry-source-file="index.tsx">{children}</AppLayoutComponent>
        </Suspense>;
};
export default AppLayout;